<template>
  <div>
    <span class="title">维度：</span>
    <div class="dimens">
      <el-checkbox-group v-model="checkedDimens">
        <el-checkbox v-for="(item, index) in dimensions" :label="item.key" :key="index" :disabled="item.disabled" :checked="item.checked">
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'dimensionBeta',
  props: {
    config: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    dimensions() {
      if (isArray(this.config)) {
        return this.config.map((c) => {
          return {
            key: c.d_key,
            label: c.title,
            checked: c.checked,
            disabled: c.disabled
          }
        })
      }
      return []
    }
  },
  watch: {
    checkedDimens(nVal, oVal) {
      const cols = this.config
        .filter((c) => nVal.includes(c.d_key))
        .map((c) => {
          return {
            key: c.key,
            title: c.title,
            fixed: c.fixed,
            width: c.width
          }
        })
      this.$emit('on-change', { cols, dims: nVal })
    }
  },
  data() {
    return {
      checkedDimens: []
    }
  }
}
</script>
<style lang="scss" scoped>
.el-checkbox-group {
  display: inline-block;
}
.dimens {
  display: inline-block;
  margin-left: 10px;
  .el-checkbox {
    margin-right: 10px;
  }
  padding-bottom: 8px;
}
</style>
